import React, { useRef, useEffect } from 'react'
import Logocomponent from './Logocomponent'



export default function Partnerslogocontainer({data}) {

  // filter logos based on type
  const filterLogos = (type) => {
    return data.filter((item) => item.type === type);
  };

  const logosrounded = filterLogos("round");
  const logosrectangle = filterLogos("rectangle");

  console.log("rounded",logosrounded);
  console.log(logosrectangle);

  return (
    <div className="relative w-full flex flex-col py-5">
      {logosrounded.length > 0 && (
        <div className="flex flex-wrap max-w-5xl mx-auto items-center  justify-center  gap-5 px-20 md:px-32  pb-5 cursor-pointer">
          {logosrounded.map((item) => (
            <div
              key={item.id}
              className="bg-white 2xl:w-[6rem] 2xl:h-[6rem] 2xl:rounded-[3rem] md:w-[4rem] md:h-[4rem] md:rounded-[2rem] w-[2rem] h-[2rem] rounded-[1rem]"
            >
              <img
                className="2xl:w-[6rem] 2xl:h-[6rem] 2xl:rounded-[3rem] md:w-[4rem] md:h-[4rem] md:rounded-[2rem] w-[2rem] h-[2rem] rounded-[1rem] partners-custom"
                src={item.image}
              ></img>
            </div>
          ))}
        </div>)}
      {logosrectangle.length > 0 && (
        <div className="flex flex-wrap max-w-5xl mx-auto items-center  justify-center  gap-5  md:px-32 cursor-pointer">
          {logosrectangle.map((item) => (
            <div key={item.id}>
              <Logocomponent id={item.id} img={item.image} />
            </div>
          ))}
        </div>
      )}
      <div
        className="absolute -z-2 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[28rem] md:h-[12rem]"
        style={{
          background:
            "radial-gradient(circle at center, rgba(77,118,244,0.4), transparent )",
          filter: "blur(70px)",
        }}
      ></div>
    </div>
  );
}
